import TypesCheck from 'global-libs/under-score/types-check';
export default class Event{
    constructor(){
        this.declareVars();
    }
    //----------------------------------------内部属性方法----------------------------------------
    declareVars(){
        //----------私有----------
        this._handles = {};
        this._onceHandles = {};
    }

    //触发事件的函数
    _dispatch (e){
        let handles = this._handles[e.type];
        let nullIndexs = [];
        if(TypesCheck.isArray(handles)){
            handles.forEach((handle,index)=>{
                if(handle){
                    handle(e);
                }else {
                    nullIndexs.push(index);
                }
            });
            for(let i=nullIndexs.length-1; i>-1; i--){
                handles.splice(nullIndexs[i],1);
            }
            if(handles.length<1){
                delete this._handles[e.type];
            }
        }

        handles = this._onceHandles[e.type];
        if(TypesCheck.isArray(handles)){
            handles.forEach((handle)=>{
                if(handle){
                    handle(e);
                }
            });
            delete this._onceHandles[e.type];
        }
    }

    //----------------------------------------对外属性方法----------------------------------------
    debug(){
        console.log({...this._handles,...this._onceHandles});
    }

    //添加事件
    addEventListener(eventType,handle){
        this._handles[eventType] = this._handles[eventType] || [];
        if(this._handles[eventType].indexOf(handle)===-1){
            this._handles[eventType].push(handle);
        }
    }

    //添加一次性触发
    addEventListenerOnce(eventType,handle){
        this._onceHandles[eventType] = this._onceHandles[eventType] || [];
        if(this._onceHandles[eventType].indexOf(handle)===-1){
            this._onceHandles[eventType].push(handle);
        }
    }

    //移除事件
    removeEventListener(eventType,handle){
        //移除普通事件
        let handles = this._handles[eventType];
        let index = -1;
        if(handles){
            index = handles.indexOf(handle);
            if(index!==-1){
                handles[index] = null;
            }
        }

        //移除一次性触发事件
        handles = this._onceHandles[eventType];
        if(handles){
            index = handles.indexOf(handle);
            if(index!==-1){
                handles[index] = null;
            }
        }
    }

    /**
     * 清空事件
     * @param eventType {String} 不传参时清除所有事件
     */
    clear(eventType){
        if(eventType){
            delete this._handles[eventType];
            delete this._onceHandles[eventType];
        }else{
            this._handles = {};
        }
    }

    // 触发事件
    dispatchEvent(...events){
        events.forEach((event)=>{
            this._dispatch(event);
        });
    }

    //是否包含特定类型的事件
    isContain(eventType){
        let handlesContain = (handles)=>{
            if(handles){
                for(let i=0,len=handles.length; i<len; i++){
                    if(handles[i]){
                        return true;
                    }
                }
                return false;
            }
            return false;
        };
        if(eventType){
            if(handlesContain(this._handles[eventType])){
                return true;
            }
            return handlesContain(this._onceHandles[eventType]);
        }
        let mapContain = (handleMap)=>{
            for(let key in handleMap){
                let handles = handleMap[key];
                if(handles){
                    for(let i=0,len=handles.length; i<len; i++){
                        if(handles[i]){
                            return true;
                        }
                    }
                }
            }
            return false;
        };
        if(mapContain(this._handles)){
            return true;
        }
        return mapContain(this._onceHandles);
    }
}